import { promisify } from "./utils/Promisify";

function initiateApprovalProcessFnDescriptor(
  processId: string,
  switchValue: string,
  executeCondition: string,
  triggerSetting: string,
  debounceAndThrottleTime: number,
) {
  return {
    type: "INITIATE_APPROVAL_PROCESS" as const,
    payload: {
      processId,
      switchValue,
      executeCondition,
      triggerSetting,
      debounceAndThrottleTime,
    },
  };
}

function submitApprovalProcessFormFnDescriptor(data: any) {
  return {
    type: "SUBMIT_APPROVAL_PROCESS_FORM" as const,
    payload: { data },
  };
}

export type TInitiateApprovalProcessDescription = ReturnType<
  typeof initiateApprovalProcessFnDescriptor
>;

export type TInitiateApprovalProcessArgs = Parameters<
  typeof initiateApprovalProcessFnDescriptor
>;

export type TSubmitApprovalProcessFormDescription = ReturnType<
  typeof submitApprovalProcessFormFnDescriptor
>;

export type TSubmitApprovalProcessFormArgs = Parameters<
  typeof submitApprovalProcessFormFnDescriptor
>;

export type TInitiateApprovalProcessActionType =
  TInitiateApprovalProcessDescription["type"];

export type TSubmitApprovalProcessFormActionType =
  TSubmitApprovalProcessFormDescription["type"];

async function initiateApprovalProcess(
  ...args: Parameters<typeof initiateApprovalProcessFnDescriptor>
) {
  return promisify(initiateApprovalProcessFnDescriptor)(...args);
}

export function submitApprovalProcessForm(
  ...args: Parameters<typeof submitApprovalProcessFormFnDescriptor>
) {
  return promisify(submitApprovalProcessFormFnDescriptor)(...args);
}

export { initiateApprovalProcess, submitApprovalProcessFormFnDescriptor };
